import {
  PayloadAction,
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import TransactionRepository from "./TransactionRepository";
import { Config } from "../../../config/Config";
import _ from "lodash";
import { EverywhereSuccessCodes } from "../../../config/EverywhereSuccessCodes";
import { EverywhereErrorCodes } from "../../../config/EverywhereErrorCodes";
import { RootState } from "../../../app/store";

export interface TransactionDetailsSlice {
  id: number;
  creditAmount: string;
  price: number;
  firstName: string;
  lastName: string;
  email: string;
}

//#region API

export const getTransactionDetailsAsync = createAsyncThunk(
  "getTransactionDetailsAsync/getTransactionDetails",
  async (data: { transactionalSummaryId: number }) => {
    const transactionRepository = new TransactionRepository();
    const response = await transactionRepository.getTransactionDetails(
      data.transactionalSummaryId
    );
    const transactionDetails = _.get(response, Config.USER_INFO_RESPONSE);
    return transactionDetails;
  }
);

//#endRegion API

//#region Slice

const transactionDetailsAdapter = createEntityAdapter<TransactionDetailsSlice>({
  selectId: (transactionDetails) => transactionDetails.id,
});

export const transactionDetailsSlice = createSlice({
  name: "transactionDetailsSlice",
  initialState: transactionDetailsAdapter.getInitialState({
    status: "idle",
    reasonCode: "",
  }),
  reducers: {
    transactionDetailsEmptyState: (state) => {
      transactionDetailsAdapter.setAll(state, []);
      state.reasonCode = "";
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getTransactionDetailsAsync.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          transactionDetailsAdapter.setAll(state, action.payload ?? []);
          state.statys = "idle";
          state.reasonCode = EverywhereSuccessCodes.GET;
        }
      )
      .addCase(getTransactionDetailsAsync.pending, (state: any) => {
        state.statys = "loading";
      })
      .addCase(getTransactionDetailsAsync.rejected, (state: any) => {
        state.statys = "failed";
        state.reasonCode = EverywhereErrorCodes.INTERNAL_SERVER_ERROR;
      });
  },
});

export const transactionDetailsSelector =
  transactionDetailsAdapter.getSelectors<RootState>(
    (state) => state.transactionDetails
  );

export const { transactionDetailsEmptyState } = transactionDetailsSlice.actions;
export const selectTransactionDetailsSliceStatus = (state: any) =>
  state.transactionDetails.status;
export const selectTransactionDetailsSliceReasonCode = (state: any) =>
  state.transactionDetails.reasonCode;

//#endRegion Status

export default transactionDetailsSlice.reducer;
